var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colorful-button",class:_vm.color},[_c('div',{staticClass:"number"},[_vm._v(" "+_vm._s(_vm.number)+" ")]),_c('div',{staticClass:"legend"},[_vm._v(" "+_vm._s(_vm.legend)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }